import { Injectable } from '@angular/core';
import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { CollectionResponse } from 'app/shared/models/collectionResponse.model';
import { DataService } from 'app/shared/services/data.service';
import { ProductListItemModel } from '../models/product-list-item.model';
import { ListRequestModel } from 'app/api/models/list-request.model';
import { Filter, FilterOperatorType } from 'app/shared/models/filter.model';

@Injectable({ providedIn: 'root' })
export class CompanyProductListService extends DataService<any> {

  companyId: number;
  itemsCount: number = 0;
  pageCount: number = 0;

  constructor(private apiDependencies: ApiDependenciesService) {
    super(apiDependencies);
  }

  getCompanyProductListEndpoint(): string {
    return '/company-product-list' + '/' + this.companyId;
  }

  getMappedListItemDataModel(responseItem: any): ProductListItemModel {
    const model: ProductListItemModel = responseItem;
    return model;
  }

  async getCompanyProductList(): Promise<ProductListItemModel[]> {
    const request = new ListRequestModel();
    request.filters.push(new Filter('IsActive', new FilterOperatorType().Equals, true));

    let result: ProductListItemModel[] = [];
    await this
      .setEndpoint(this.getCompanyProductListEndpoint())
      .queryCollection(request)
      .then((response: CollectionResponse<any>) => {
        if (response != null) {
          this.itemsCount = response.itemsCount;
          this.pageCount = Math.ceil(this.itemsCount / request.pageSize);
          result = response.items.map(item => this.getMappedListItemDataModel(item));
        }
      });

    return Promise.resolve(result);
  }
}
